import { lazyNamed } from 'src/utils/lazyNamed.ts';

export const BroadcastProducts = {
  AdMedia: lazyNamed(() => import('./pages/AdMedia/index.tsx'), 'AdMedia'),
  AdMediaHistory: lazyNamed(() => import('./pages/AdMedia/containers/AdMediaHistory.tsx'), 'AdMediaHistory'),

  AdPlacements: lazyNamed(() => import('./pages/AdPlacements/index.tsx'), 'AdPlacements'),
  AdPlacementForm: lazyNamed(() => import('./pages/AdPlacements/containers/AdPlacementForm/index.tsx'), 'AdPlacementForm'),
  AdPlacementHistory: lazyNamed(() => import('./pages/AdPlacements/containers/AdPlacementHistory.tsx'), 'AdPlacementHistory'),

  AdTypes: lazyNamed(() => import('./pages/AdTypes/index.tsx'), 'AdTypes'),
  AdTypeHistory: lazyNamed(() => import('./pages/AdTypes/containers/AdTypeHistory.tsx'), 'AdTypeHistory'),

  Products: lazyNamed(() => import('./pages/Products/index.tsx'), 'Products'),
  ProductForm: lazyNamed(() => import('./pages/Products/containers/ProductForm/index.tsx'), 'ProductForm'),
  ProductHistory: lazyNamed(() => import('./pages/Products/containers/ProductHistory.tsx'), 'ProductHistory'),

  AdPrices: lazyNamed(() => import('./pages/AdPrices/index.tsx'), 'AdPrices'),
  CreateAdPriceForm: lazyNamed(() => import('./pages/AdPrices/containers/CreateAdPriceForm/index.tsx'), 'CreateAdPriceForm'),
  EditAdPriceForm: lazyNamed(() => import('./pages/AdPrices/containers/EditAdPriceForm/index.tsx'), 'EditAdPriceForm'),
  AdPriceHistory: lazyNamed(() => import('./pages/AdPrices/containers/AdPriceHistory.tsx'), 'AdPriceHistory'),
};
